/* ══════════════════════════════════════════════════════════════
   MIOTOTS Global — AJAX Cart + Wishlist + UI Feedback
   ══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Wishlist (localStorage) ── */
  var WL_KEY = 'miotots_wishlist';

  function getWL() {
    try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveWL(ids) { localStorage.setItem(WL_KEY, JSON.stringify(ids)); updateWLBadge(); }

  function updateWLBadge() {
    var count = getWL().length;
    document.querySelectorAll('.mh-wl-badge').forEach(function (b) {
      b.textContent = count > 0 ? count : '';
      if (count > 0) { b.removeAttribute('hidden'); }
      else { b.setAttribute('hidden', ''); }
    });
  }

  function toggleWL(productId, btn) {
    var ids = getWL();
    var idx = ids.indexOf(productId);
    if (idx > -1) {
      ids.splice(idx, 1);
      if (btn) btn.classList.remove('is-active');
    } else {
      ids.push(productId);
      if (btn) btn.classList.add('is-active');
    }
    saveWL(ids);
    showToast(idx > -1 ? 'Removed from Wishlist' : 'Added to Wishlist ❤️');
  }

  function syncWLButtons() {
    var ids = getWL();
    document.querySelectorAll('.home-wishlist-btn, .card-wishlist-btn-mobile, .pdw-wishlist-btn').forEach(function (btn) {
      var pid = parseInt(btn.dataset.productId);
      if (ids.indexOf(pid) > -1) btn.classList.add('is-active');
      else btn.classList.remove('is-active');
    });
  }

  /* ── AJAX Cart Add ── */
  function ajaxAddToCart(form, btn) {
    if (btn) {
      btn.disabled = true;
      btn.dataset.origText = btn.innerHTML;
      btn.innerHTML = '<span class="miotots-spinner"></span> Adding...';
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function (r) { return r.json(); })
    .then(function (item) {
      if (btn) {
        btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg> Added!';
        btn.classList.add('is-added');
      }
      fetchCartCount();
      showToast('Added to Cart 🛒');
      setTimeout(function () {
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = btn.dataset.origText || 'Add to Cart';
          btn.classList.remove('is-added');
        }
      }, 1800);
    })
    .catch(function (err) {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = btn.dataset.origText || 'Add to Cart';
      }
      showToast('Could not add to cart. Please try again.');
    });
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.mh-cart-badge').forEach(function (badge) {
          badge.textContent = cart.item_count > 0 ? cart.item_count : '';
          badge.setAttribute('data-count', cart.item_count);
          if (cart.item_count > 0) {
            badge.removeAttribute('hidden');
            badge.classList.remove('pop');
            void badge.offsetWidth;
            badge.classList.add('pop');
          } else {
            badge.setAttribute('hidden', '');
          }
        });
      })
      .catch(function () {});
  }

  /* ── Toast ── */
  var toastEl = null;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'miotots-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 2200);
  }

  /* ── Bind Events ── */
  function init() {
    /* Cart forms — AJAX */
    document.querySelectorAll('.card-cart-form, #pdw-add-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        ajaxAddToCart(form, btn);
      });
    });

    /* Wishlist buttons — all types */
    document.querySelectorAll('.home-wishlist-btn, .card-wishlist-btn-mobile, .pdw-wishlist-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleWL(parseInt(this.dataset.productId), this);
      });
    });

    /* Sync active states on load */
    syncWLButtons();
    updateWLBadge();
    fetchCartCount();
  }

  /* ── Run after DOM ready ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Expose for dynamic content (e.g., search results, infinite scroll) */
  window.MIOTOTS = window.MIOTOTS || {};
  window.MIOTOTS.initCards = init;
  window.MIOTOTS.fetchCartCount = fetchCartCount;
  window.MIOTOTS.syncWLButtons = syncWLButtons;
})();
